import { z } from "zod";
export const deskPaymentMethodSchema = z.enum(["mobilepay", "cash", "other"]);
// POST /internal/desk/sales
export const deskSaleRequestSchema = z.object({
    requestId: z.string().uuid(),
    email: z.string().trim().email().max(254),
    firstName: z.string().trim().min(1).max(100),
    lastName: z.string().trim().min(1).max(100),
    phone: z.string().regex(/^\+358[1-9]\d{5,9}$/).optional(),
    items: z
        .array(z.object({
        lookupKey: z.string().min(1).max(200),
        chargedCents: z.number().int().min(0).max(100000),
    }))
        .min(1)
        .max(5),
    eventName: z.string().trim().min(1).max(120),
    paymentMethod: deskPaymentMethodSchema,
    posReference: z.string().trim().min(1).max(60).optional(),
});
const deskPriceSchema = z.object({
    lookupKey: z.string(),
    productName: z.string(),
    unitAmountCents: z.number(),
});
// GET /internal/desk/products
export const deskProductsResponseSchema = z.object({
    items: z.array(deskPriceSchema.extend({ addons: z.array(deskPriceSchema) })),
});
export const deskSaleResponseSchema = z.object({
    orderNumber: z.string(),
    items: z.array(z.object({ productName: z.string(), chargedCents: z.number() })),
    totalCents: z.number(),
    createdAt: z.string(),
    duplicate: z.boolean(),
    workDomainEmail: z.boolean(),
    // Whether the buyer has been sent an order confirmation -- by this request,
    // or already by the first one on a replay. False means the send failed and
    // the sale needs a resend (POST .../confirmation-email).
    confirmationEmailSent: z.boolean(),
});
// POST /internal/desk/sales/:orderNumber/pos-reference -- set once, never changed.
export const deskPosReferenceRequestSchema = z.object({
    posReference: z.string().trim().min(1).max(64),
});
export const deskPosReferenceResponseSchema = z.object({ orderNumber: z.string() });
// POST /internal/desk/sales/:orderNumber/confirmation-email -- sends the order
// confirmation to the buyer again, or for the first time if it never went out.
export const deskConfirmationEmailResponseSchema = z.object({
    orderNumber: z.string(),
    confirmationEmailSentAt: z.string().nullable(),
});
// GET /internal/desk/sales/recent -- deliberately no buyer fields.
export const deskRecentSalesResponseSchema = z.object({
    sales: z.array(z.object({
        orderNumber: z.string(),
        productNames: z.array(z.string()),
        totalCents: z.number(),
        createdAt: z.string(),
        eventName: z.string(),
        recordedByEmail: z.string(),
        paymentMethod: deskPaymentMethodSchema,
        hasPosReference: z.boolean(),
        glideStatus: z.enum(["pending", "sent", "dead"]),
        // When the first order confirmation went out; null if it never has.
        confirmationEmailSentAt: z.string().nullable(),
    })),
});
